<div class="full-width" fxLayout="column" fxLayoutGap="20px" fxFlexOffset="30px">
  <div class="info-card" fxLayout="column" *ngIf="survey">
    <div fxLayout="row" fxLayoutGap="15px">
      <!-- Left Column: Non-Updatable Fields -->
      <div fxLayout="column" fxLayoutGap="15px" fxFlex="50">
        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Survey UUID</span>
          <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%; max-width: 300px">
            <input matInput [value]="displayUuid(survey.uuid!)" disabled>
          </mat-form-field>
        </div>

        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Survey Code</span>
          <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%; max-width: 300px">
            <input matInput [value]="survey.code" disabled>
          </mat-form-field>
        </div>

        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Survey Status</span>
          <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%; max-width: 300px">
            <input matInput [value]="survey.status" disabled>
          </mat-form-field>
        </div>

        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Allow Multiple Submissions</span>
          <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%; max-width: 300px">
            <input matInput [value]="survey.allowMultiSubmission ? 'Yes' : 'No'" disabled>
          </mat-form-field>
        </div>
      </div>

      <!-- Right Column: Updatable Form -->
      <div fxLayout="column" fxLayoutGap="20px" fxFlex="50">
        <form [formGroup]="surveyForm" class="full-width"
              fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px"
              (ngSubmit)="onSubmit()">
          <!-- Survey Name -->
          <div class="full-width" fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">Survey Name</span>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%; max-width: 300px">
              <input matInput formControlName="name" placeholder="Enter survey name">
              <mat-error *ngIf="surveyForm.get('name')!.hasError('required')">
                Survey name is required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Survey Display Title -->
          <div class="full-width" fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">Survey Display Title</span>
            <mat-form-field class="custom-text-field" appearance="outline" style="width: 100%; max-width: 300px">
              <input matInput formControlName="displayTitle" placeholder="Enter survey display title">
              <mat-error *ngIf="surveyForm.get('displayTitle')!.hasError('required')">
                Survey display title is required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Audience -->
          <div class="full-width" fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">Audience</span>
            <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%; max-width: 300px">
              <mat-select formControlName="audience" placeholder="Select">
                <mat-option [value]="AudienceCategory.GENERAL_PUBLIC">General public</mat-option>
                <mat-option [value]="AudienceCategory.MERCHANTS">Merchants</mat-option>
              </mat-select>
              <mat-error *ngIf="surveyForm.get('audience')!.hasError('required')">
                Audience is required
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Start Date -->
          <div class="full-width" fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">Start Date</span>
            <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%; max-width: 300px">
              <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Select start date">
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
              <mat-error *ngIf="surveyForm.get('startDate')!.hasError('required')">
                Start date is required
              </mat-error>
              <mat-error *ngIf="surveyForm.errors?.['dateOrder']">
                {{ surveyForm.errors?.['dateOrder'] }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- End Date -->
          <div class="full-width" fxLayout="column" fxLayoutGap="7px">
            <span class="body-3-default">End Date (optional)</span>
            <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%; max-width: 300px">
              <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Select end date">
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
